"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingStateActionTypes = void 0;
/*
 * Copyright 2023, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
var LoadingStateActionTypes;
(function (LoadingStateActionTypes) {
    LoadingStateActionTypes["INCREMENT_LOADING_STATE"] = "INCREMENT_LOADING_STATE";
    LoadingStateActionTypes["DECREMENT_LOADING_STATE"] = "DECREMENT_LOADING_STATE";
})(LoadingStateActionTypes || (exports.LoadingStateActionTypes = LoadingStateActionTypes = {}));
//# sourceMappingURL=types.js.map